export function getSetting(name, appSettings) {
    const result = appSettings.settings.find((setting) => {
        return setting.name === name;
    });
    return result !== null && result !== void 0 ? result : null;
}
export function getSettingValue(name, appSettings) {
    const setting = getSetting(name, appSettings);
    return setting ? setting.value : null;
}
